import { useMemo } from 'react';
import { AgeBucket, CriteriaKey, SepsisState } from '../types';
import { evalTemp, evalHR, evalBP } from '../utils/thresholdEval';
import thresholds from '../data/sepsisThresholds.json';

interface UseSepsisScoreResult {
  activeButtons: Record<CriteriaKey, boolean>;
  score: number;
  isHighRisk: boolean;
}

export const useSepsisScore = (state: SepsisState): UseSepsisScoreResult => {
  const ageBucketMap = useMemo(() => {
    const map = new Map<string, AgeBucket>();
    (thresholds.ageBuckets as AgeBucket[]).forEach((b) => map.set(b.id, b));
    return map;
  }, []);

  const currentBucket = useMemo(
    () => (state.age ? ageBucketMap.get(state.age) ?? null : null),
    [state.age, ageBucketMap]
  );

  const activeButtons = useMemo((): Record<CriteriaKey, boolean> => {
    return { ...state.manualToggles };
  }, [state.manualToggles]);

  const score = useMemo(
    () => Object.values(activeButtons).filter(Boolean).length,
    [activeButtons]
  );

  const isHighRisk = score >= 3;

  return { activeButtons, score, isHighRisk };
};
